import { useEffect, useRef } from 'react';
import { AccountResponse } from '../../../../shared/models/account/AccountResponse';
import useDataLayer, { IProjectDataLayer } from '../../../../shared/hooks/global/UseDataLayer';
import { FIRST_CHATBEAT_PROJECT_KEY } from '../helpers/ProjectPreviewHelper';

interface UseFirstViewTrackingProps {
  projectId: number;
  accountResponse: AccountResponse | null;
  isDataReady: boolean;
}

export const useFirstViewTracking = ({
  projectId,
  accountResponse,
  isDataReady,
}: UseFirstViewTrackingProps): void => {
  const { pushDataLayer } = useDataLayer();
  const hasTrackedRef = useRef(false);

  useEffect(() => {
    if (!accountResponse || hasTrackedRef.current || !isDataReady) {
      return;
    }

    const newProjectFlag = localStorage.getItem(FIRST_CHATBEAT_PROJECT_KEY);

    if (!newProjectFlag) {
      return;
    }

    pushDataLayer<IProjectDataLayer>({
      event: 'first_results_viewed',
      project_id: projectId.toString(),
      email_hashed: accountResponse.email,
      user_id: accountResponse.userId.toString(),
      account_id: accountResponse.accountId.toString(),
    });

    localStorage.removeItem(FIRST_CHATBEAT_PROJECT_KEY);
    hasTrackedRef.current = true;
  }, [accountResponse, isDataReady, projectId, pushDataLayer]);
};
